import { render, staticRenderFns } from "./TimetableNavigation.vue?vue&type=template&id=65d51159"
import script from "./TimetableNavigation.vue?vue&type=script&lang=js"
export * from "./TimetableNavigation.vue?vue&type=script&lang=js"
import style0 from "./TimetableNavigation.vue?vue&type=style&index=0&id=65d51159&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports